export default __webpack_public_path__ + "static/headshot-a9ff78d2009d808844405eeb9777abda.jpg";